import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import {
  useUpdateMeetingMutation,
  useUpdateStagesMutation,
  useGetCalendlyLinkQuery,
} from "../../services/api";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../store/store";
import { setStage } from "../../store/reducers/stageReducer";
import { toggleSubmission } from "../../store/reducers/tileReducer";
import { tracker } from "../../services/mixpanel";
import { config } from "../../configs/index";

interface EquityModalProps {
  isOpen: boolean;
  onClose: () => void;
  setIsEventTrigger: React.Dispatch<React.SetStateAction<boolean>>;
  isEventTrigger: boolean;
}



const CalendlyComponent: React.FC<EquityModalProps> = ({
  isOpen,
  onClose,
  setIsEventTrigger,
  isEventTrigger,
}) => {
  const dispatch = useAppDispatch();
  const stageData = useSelector((state: RootState) => state.stage);
  const [errors, setErrors] = useState<{ [key: string]: string | null }>({});
  const zohoCustomerId = useSelector(
    (state: RootState) => state.login.zohoCustomerId
  );
  const purlUser = useSelector((state: RootState) => state.purlUser);
  const { data: calendlyData } = useGetCalendlyLinkQuery(purlUser.contactOwner || "", {
    skip: !purlUser.contactOwner || !isOpen,
  });

  const [updateStage] = useUpdateStagesMutation();
  const [evenId, setEvenId] = useState<string>("");
  const [updateMeeting] = useUpdateMeetingMutation();
  const calendlyUrl = calendlyData?.data?.calendlyLink || config.REACT_APP_CALENDLY_URL;

  useEffect(() => {
    if (isOpen) {
      setErrors({});
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && calendlyUrl && calendlyUrl.includes("calendly.com")) {
      tracker.dashboard.scheduleACallWithCPA.calendlyWidget.onView(calendlyUrl);
    }
  }, [isOpen, calendlyUrl]);

  useCalendlyEventListener({
    onProfilePageViewed: () => console.log("onProfilePageViewed"),
    onDateAndTimeSelected: () => console.log("onDateAndTimeSelected"),
    onEventTypeViewed: () => console.log("onEventTypeViewed"),
    onEventScheduled: (e) => {
      const uri = e.data.payload.event.uri;
      const eveId = uri.split("https://api.calendly.com/scheduled_events/")[1];

      setEvenId(eveId);
    },
  });

  useEffect(() => {
    if (evenId !== "") {
      handleStage();
    }
  }, [evenId]);

  const updateEventInUser = async () => {
    try {
      const sendData = {
        zohoId: zohoCustomerId,
        eventId: evenId,
      };

      const result = await updateMeeting(sendData);
      setIsEventTrigger(!isEventTrigger);
    } catch (err) {
      console.log("Error", err);
    }
  };
  const handleStage = async () => {
    if (stageData.cpaCallComplete && evenId) {
      updateEventInUser();
      return;
    }
    try {
      await updateStage({
        zohoId: zohoCustomerId,
        key: "cpaCallComplete",
        eventId: evenId,
      });
      dispatch(
        setStage({
          ...stageData,
          cpaCallComplete: true,
        })
      );

      dispatch(toggleSubmission({ component: "tile2" }));
      setIsEventTrigger(!isEventTrigger);
    } catch (err) {
      console.log(`Error`, err);
    }
  };

  if (!isOpen) return null;


  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h3 className={styles.modalTitle}>Schedule Call with Us</h3>
          <button className={styles.closeButton} onClick={() => {
            tracker.dashboard.scheduleACallWithCPA.onClose();
            onClose();
          }}
          >
            &times;
          </button>
        </div>
        {calendlyUrl && calendlyUrl.includes("calendly.com") ? (
          <InlineWidget url={calendlyUrl} />
        ) : calendlyUrl ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px" }}>
            <p style={{ marginBottom: "20px", fontSize: "18px", textAlign: "center" }}>
              Please click the button below to schedule the meeting.
            </p>
            <a
              href={calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.submitButton}
              style={{ textDecoration: "none", display: "inline-block" }}
              onClick={() => {
                tracker.dashboard.scheduleACallWithCPA.joinMeeting.onClick("external", calendlyUrl);
              }}
            >
              Join Meeting
            </a>
          </div>
        ) : (
          <p className="text-center text-red-500">Something went wrong</p>
        )}
      </div>
    </div>
  );
};

export default CalendlyComponent;
